import { useMemo } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';

import {
  CatalogSource,
  MapEditorCatalogElement,
  resolveCatalogElements,
} from './mapEditorCatalog';

export interface UseMapEditorCatalogResult {
  elements: MapEditorCatalogElement[];
  // 'build' means the streamed build shipped its own catalog through the GameCast metadata
  // provider; 'fallback' means it did not, and `elements` comes back empty. useCanUseMapEditor
  // reads this to decide whether the map has a map editor at all.
  source: CatalogSource;
  // Id of the element that closes a chain, already checked against `elements`. Empty when this
  // build ships no cap — the chain then ends in an open doorway, which is a valid layout.
  defaultEndElement: string;
}

/**
 * The room kit this map's build shipped.
 *
 * @returns The normalised elements, where the catalog came from, and the id of the chain cap.
 */
export const useMapEditorCatalog = (): UseMapEditorCatalogResult => {
  const { currentRoom } = useMytaverseEvent();
  const layoutCatalog = currentRoom?.map?.layoutCatalog;

  return useMemo(() => resolveCatalogElements(layoutCatalog), [layoutCatalog]);
};
